import { formatEther } from 'ethers'
import { useEffect } from 'react'

import { useAddRecentTransaction } from '@rainbow-me/rainbowkit'
import { useAccount, useSimulateContract, useWriteContract } from 'wagmi'

import useTokenGGPContract from './contracts/tokenGGP'

import { useValueTokens } from '@/contexts/VaultTokensContext'

export const useApproveGGPtoVault = (amount: bigint) => {
  const { currentToken } = useValueTokens()
  const { chain } = useAccount()
  const vaultAddress = currentToken.tokenAddresses[1][chain?.id]
  const { abi, address: ggpTokenAddress } = useTokenGGPContract()

  const addRecentTransaction = useAddRecentTransaction()

  const simulation = useSimulateContract({
    address: ggpTokenAddress,
    abi,
    functionName: 'approve',
    args: [vaultAddress, amount],
    onError(error) {
      console.warn(error)
    },
  })

  const { data: hash, error: writeError, isPending, reset, writeContract } = useWriteContract()

  useEffect(() => {
    if (hash) {
      addRecentTransaction({
        hash,
        description: `Approve ${formatEther(amount)} GGP`,
      })
    }
  }, [hash, addRecentTransaction, amount])

  return {
    hash,
    simulation,
    writeContract,
    reset,
    isPending,
    writeError,
    ready: writeContract !== undefined,
  }
}
